export default __webpack_public_path__ + "static/media/02.e757d956.jpg";